// extracted by mini-css-extract-plugin
export default {"container":"ar-z","ratingLayout":"br-z","ratingLabel":"cr-z","nonInteractiveRatingLabel":"dr-z"};